import { TermsAndConditionsForm } from '../components/TermsAndConditionsModal/types'

class SaveAcceptTermData {
  toPersistence(data: TermsAndConditionsForm) {
    return {
      cpf: data.cpf,
      dataNascimento: data.birthDate,
      email: data.email,
      telefone: data.phone,
    }
  }
}

export default new SaveAcceptTermData()
